import {NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';

import {ViewModule} from 'app/views/view.module';
import {RouterModule} from "@angular/router";
import {TemplateTagComponent} from "./template_tag/template_tag.component";
import {TemplateTagDetailsComponent} from "./template_tag/details/details.component";
import {SiteCategoriesComponent} from "./site_categories/site_categories.component";
import {SiteCategoryDetailsComponent} from "./site_categories/details/site_category_details.component";
import {CategoryDynamicsComponent} from "./category_dynamics/category_dynamics.component";
import {SiteSubCategoriesComponent} from "app/template/site_sub_categories/site_sub_categories.component";
import {SiteSubCategoriesService} from "./site_sub_categories/site_sub_categories.service";
import { TemplateService } from "./template.service";
import { TemplateComponent } from "./template/template.component";

@NgModule({
	imports: [
		ViewModule,
		HttpClientModule,
		RouterModule
	],

	declarations: [
		TemplateTagComponent,
		SiteCategoriesComponent,
		SiteCategoryDetailsComponent,
		SiteSubCategoriesComponent,
		CategoryDynamicsComponent,
		TemplateTagDetailsComponent,
		TemplateComponent,
	],

	providers: [
		SiteSubCategoriesService,
		TemplateService,
	],

	entryComponents: [
		TemplateTagDetailsComponent,
		SiteCategoryDetailsComponent
	]
})
export class TemplateModule {
}
